__turbopack_context__.v({
  "comingSoon": "Sidebar-module__a0xGaq__comingSoon",
  "root": "Sidebar-module__a0xGaq__root",
});
